var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.958 14.325C19.162 13.839 18.579 13.425 18.09 13.641C17.1126 14.07 16.0565 14.2907 14.989 14.289C10.804 14.289 7.412 10.965 7.412 6.864C7.41047 5.47934 7.80385 4.12297 8.546 2.954C8.83 2.506 8.489 1.886 7.969 2.018C3.96 3.041 1 6.613 1 10.862C1 15.909 5.175 20 10.326 20C14.226 20 17.566 17.655 18.958 14.325Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.611 2.10298C13.081 1.74898 12.449 2.38098 12.802 2.91098L13.432 3.85598C13.6876 4.23914 13.824 4.6894 13.824 5.14998C13.824 5.61055 13.6876 6.06081 13.432 6.44398L12.802 7.38898C12.449 7.91898 13.082 8.55098 13.612 8.19698L14.556 7.56698C14.9392 7.31141 15.3894 7.17503 15.85 7.17503C16.3106 7.17503 16.7608 7.31141 17.144 7.56698L18.089 8.19698C18.619 8.55098 19.251 7.91898 18.897 7.38898L18.267 6.44398C18.0114 6.06081 17.8751 5.61055 17.8751 5.14998C17.8751 4.6894 18.0114 4.23914 18.267 3.85598L18.897 2.91098C19.251 2.38098 18.619 1.74898 18.088 2.10298L17.144 2.73298C16.7608 2.98854 16.3106 3.12493 15.85 3.12493C15.3894 3.12493 14.9392 2.98854 14.556 2.73298L13.611 2.10298V2.10298Z",
    stroke: "black",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.afed587128ea5df7de82ab11dbf1c13b.svg";
export { ForwardRef as ReactComponent };